import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSearch1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24.38 19.81h-1.53v3.05h-3.04v1.52h-3.05v1.52h4.57v1.53h1.52v1.52h1.53v1.53h1.52V32h1.53v-1.52h1.52v-1.53h1.52v-1.52H32V25.9h-1.53v-1.52h-1.52v-1.52h-1.52v-1.53H25.9v-4.57h-1.52zm1.52-9.14h1.53v6.09H25.9Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52 7.62h1.52v3.05h-1.52Zm-1.52-3.05h1.52v3.05h-1.52Zm0-6.09h3.04v1.52h-3.04Zm-3.05 4.57h3.05v1.52h-3.05Zm0-6.1h3.05v1.53h-3.05ZM13.71 6.1h3.05v1.52h-3.05Zm-3.05 19.8h6.1v1.53h-6.1Zm0-25.9h6.1v1.52h-6.1ZM7.62 24.38h3.04v1.52H7.62Zm0-22.86h3.04v1.53H7.62ZM4.57 22.86h3.05v1.52H4.57Zm0-19.81h3.05v1.52H4.57ZM3.05 19.81h1.52v3.05H3.05Zm0-15.24h1.52v3.05H3.05ZM1.52 16.76h1.53v3.05H1.52Zm0-9.14h1.53v3.05H1.52ZM0 10.67h1.52v6.09H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSearch1
